var _excluded = ["content", "onAction", "plain", "destructive"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import { Button } from './Button.js';
function buttonsFrom(actions) {
  var overrides = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (Array.isArray(actions)) {
    return actions.map(function (action, index) {
      return buttonFrom(action, overrides, index);
    });
  } else {
    var action = actions;
    return buttonFrom(action, overrides);
  }
}
function buttonFrom(_ref, overrides, key) {
  var content = _ref.content,
    onAction = _ref.onAction,
    plain = _ref.plain,
    destructive = _ref.destructive,
    action = _objectWithoutProperties(_ref, _excluded);
  var plainVariant = plain ? 'plain' : undefined;
  var destructiveVariant = destructive ? 'primary' : undefined;
  var tone = !(overrides !== null && overrides !== void 0 && overrides.tone) && destructive ? 'critical' : overrides === null || overrides === void 0 ? void 0 : overrides.tone;
  return /*#__PURE__*/React.createElement(Button, Object.assign({
    key: key,
    onClick: onAction,
    tone: tone,
    variant: plainVariant || destructiveVariant
  }, action, overrides), content);
}
export { buttonFrom, buttonsFrom };